"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var requiring_action_html_1 = __importDefault(require("./requiring-action.html"));
var requiring_action_controller_1 = __importDefault(require("./requiring-action.controller"));
function config($stateProvider, $urlRouterProvider) {
    $stateProvider.state("drivecoach.admin.drives.actionrequired", {
        url: "/requiring-action",
        controller: "DrivesRequiringActionController",
        controllerAs: "vm",
        template: requiring_action_html_1.default,
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("drivecoach.admin.drives.requiringaction", [])
    .config(config)
    .controller("DrivesRequiringActionController", requiring_action_controller_1.default);
